export enum PreviewView {
    DESKTOP = "DESKTOP",
    MOBILE = "MOBILE",
    PDF = "PDF",
}

export enum Views {
    INTRO,
    EXERCISES,
    OUTRO,
    UNAUTHORIZED,
}
